import * as cn from 'classnames';
import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';
import Action from '../Action';
export default function Cta({ content, actions, theme = {} }) {
    if (!Array.isArray(actions)) {
        return null;
    }
    return (React.createElement("div", { className: theme.root },
        content && React.createElement(ReactMarkdown, { source: content, className: theme.content }),
        React.createElement("div", { className: theme.actions }, actions.map(({ className, ...actionProps }, idx) => (React.createElement("div", { key: idx, className: cn(theme.actionWrapper, (theme.actionWrappers || [])[idx]) },
            React.createElement(Action, Object.assign({}, actionProps, { className: cn(className, theme.actionLink) }))))))));
}
//# sourceMappingURL=index.js.map